import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowRight, Truck, MapPin, Mail } from "lucide-react";
import SEO from "../components/SEO";

const QUICK_LINKS = [
  { to: "/services", label: "Our Services", icon: Truck, body: "Same-day, medical, last-mile, freight & dedicated routes." },
  { to: "/service-areas", label: "Service Areas", icon: MapPin, body: "Milton, Halton Region, and the Greater Toronto Area." },
  { to: "/contact", label: "Contact Us", icon: Mail, body: "Reach our team — we reply within one business hour." },
];

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found — Ridgehawk Logistics" path="/404" noindex />
      <section className="section-pad bg-white" data-testid="not-found-page">
        <div className="container-pad">
          <div className="mx-auto max-w-3xl text-center">
            <span className="overline" data-testid="not-found-overline">404</span>
            <h1 className="h1 mt-4">We can't deliver to this page.</h1>
            <p className="body-base mt-6 text-ridge-muted">
              The page you're looking for has been rerouted or doesn't exist. Let's
              get you back on the map.
            </p>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
              <Link to="/" className="btn-primary" data-testid="not-found-home-cta">
                <HomeIcon className="h-4 w-4" />
                Back to Home
                <ArrowRight className="h-4 w-4" />
              </Link>
              <Link to="/quote" className="btn-accent" data-testid="not-found-quote-cta">
                Get a Quote
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>

          <div className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-3" data-testid="not-found-quicklinks">
            {QUICK_LINKS.map(({ to, label, icon: Icon, body }) => (
              <Link
                key={to}
                to={to}
                className="card-white group flex flex-col items-start gap-3 hover:border-ridge-amber"
                data-testid={`not-found-quick-${to.replace(/\W+/g, "-")}`}
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-ridge-stone text-ridge-amber transition-colors group-hover:bg-ridge-amber group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </span>
                <h2 className="h4">{label}</h2>
                <p className="text-sm leading-relaxed text-ridge-muted">{body}</p>
                <span className="btn-ghost-amber mt-1">
                  Visit <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
